import { render, staticRenderFns } from "./ConnectWalletWindow.vue?vue&type=template&id=6e7228e2&"
import script from "./ConnectWalletWindow.vue?vue&type=script&lang=js&"
export * from "./ConnectWalletWindow.vue?vue&type=script&lang=js&"
import style0 from "./ConnectWalletWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports